import { render, staticRenderFns } from "./PaymentMethodBanner.vue?vue&type=template&id=dc97da60"
import script from "./PaymentMethodBanner.vue?vue&type=script&lang=js"
export * from "./PaymentMethodBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports